/**
 * Skin Examination Data Points
 * Category: Skin
 */

export const skinDataPoints = [
  {
    id: 'skin_color',
    label: 'Skin Color',
    category: 'Skin',
    subcategory: 'Inspection',
    fieldType: 'single',
    isActive: true,
    placeholder: 'Select skin color',
    options: ['Normal for ethnicity', 'Pale', 'Flushed', 'Cyanotic', 'Jaundiced', 'Erythematous', 'Mottled', 'Ashen'],
    default: 'Normal for ethnicity',
    ui: {
      span: 4,
      variant: 'select',
      display: 'dropdown'
    },
    code: '364528001', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'skin_temperature',
    label: 'Skin Temperature',
    category: 'Skin',
    subcategory: 'Palpation',
    fieldType: 'single',
    isActive: true,
    placeholder: 'Select skin temperature',
    options: ['Warm', 'Cool', 'Hot', 'Cold', 'Normal temperature'],
    default: 'Normal temperature',
    ui: {
      span: 4,
      variant: 'select',
      display: 'dropdown'
    },
    code: '386725007', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'skin_moisture',
    label: 'Skin Moisture',
    category: 'Skin',
    subcategory: 'Palpation',
    fieldType: 'single',
    isActive: true,
    placeholder: 'Select skin moisture',
    options: ['Normal moisture', 'Dry', 'Moist', 'Diaphoretic', 'Clammy', 'Oily'],
    default: 'Normal moisture',
    ui: {
      span: 4,
      variant: 'select',
      display: 'dropdown'
    },
    code: '271807003', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'skin_turgor',
    label: 'Skin Turgor',
    category: 'Skin',
    subcategory: 'Palpation',
    fieldType: 'single',
    isActive: true,
    placeholder: 'Select skin turgor',
    options: ['Good turgor', 'Poor turgor', 'Tenting present', 'Delayed recoil'],
    default: 'Good turgor',
    ui: {
      span: 4,
      variant: 'select',
      display: 'dropdown'
    },
    code: '271808008', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'skin_texture',
    label: 'Skin Texture',
    category: 'Skin',
    subcategory: 'Palpation',
    fieldType: 'single',
    isActive: true,
    placeholder: 'Select skin texture',
    options: ['Smooth', 'Rough', 'Scaly', 'Thick', 'Thin', 'Leathery', 'Soft'],
    default: 'Smooth',
    ui: {
      span: 4,
      variant: 'select',
      display: 'dropdown'
    },
    code: '246204004', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'skin_integrity',
    label: 'Skin Integrity',
    category: 'Skin',
    subcategory: 'Inspection',
    fieldType: 'multi',
    isActive: true,
    placeholder: 'Select skin integrity findings',
    options: [
      'Intact',
      'Bruising',
      'Lacerations',
      'Abrasions',
      'Pressure ulcers',
      'Surgical scars',
      'Rash present',
      'Lesions present'
    ],
    default: ['Intact'],
    ui: {
      span: 8,
      variant: 'checkbox',
      display: 'chip'
    },
    code: '364528001', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'rash_description',
    label: 'Rash Description',
    category: 'Skin',
    subcategory: 'Inspection',
    fieldType: 'panel',
    isActive: true,
    nestedSubFields: true,
    subFields: [
      {
        id: 'rash_type',
        label: 'Type',
        fieldType: 'single',
        options: ['Macular', 'Papular', 'Vesicular', 'Pustular', 'Petechial', 'Purpuric'],
        ui: { span: 4 }
      },
      {
        id: 'rash_distribution',
        label: 'Distribution',
        fieldType: 'single',
        options: ['Localized', 'Generalized', 'Bilateral', 'Unilateral', 'Symmetric'],
        ui: { span: 4 }
      },
      {
        id: 'rash_location',
        label: 'Location',
        fieldType: 'multi',
        options: ['Face', 'Trunk', 'Arms', 'Legs', 'Hands', 'Feet', 'Scalp'],
        ui: { span: 4 }
      }
    ],
    code: '271807003', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'lesion_assessment',
    label: 'Lesion Assessment',
    category: 'Skin',
    subcategory: 'Inspection',
    fieldType: 'panel',
    isActive: true,
    nestedSubFields: true,
    subFields: [
      {
        id: 'lesion_size',
        label: 'Size (cm)',
        fieldType: 'numeric',
        placeholder: 'Enter size in cm',
        validation: { min: 0, max: 50, decimals: 1 },
        units: 'cm',
        ui: { span: 3 }
      },
      {
        id: 'lesion_shape',
        label: 'Shape',
        fieldType: 'single',
        options: ['Round', 'Oval', 'Irregular', 'Linear'],
        ui: { span: 3 }
      },
      {
        id: 'lesion_border',
        label: 'Border',
        fieldType: 'single',
        options: ['Well-defined', 'Ill-defined', 'Raised', 'Flat'],
        ui: { span: 3 }
      },
      {
        id: 'lesion_color',
        label: 'Color',
        fieldType: 'single',
        options: ['Red', 'Brown', 'Black', 'Blue', 'Purple', 'Pink', 'Flesh-colored'],
        ui: { span: 3 }
      }
    ],
    code: '300577008', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'nail_assessment',
    label: 'Nail Assessment',
    category: 'Skin',
    subcategory: 'Inspection',
    fieldType: 'multi',
    isActive: true,
    placeholder: 'Select nail findings',
    options: [
      'Normal nails',
      'Clubbing',
      'Cyanosis',
      'Splinter hemorrhages',
      'Pitting',
      'Ridging',
      'Brittleness',
      'Fungal infection'
    ],
    default: ['Normal nails'],
    ui: {
      span: 6,
      variant: 'checkbox',
      display: 'chip'
    },
    code: '72651009', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hair_assessment',
    label: 'Hair Assessment',
    category: 'Skin',
    subcategory: 'Inspection',
    fieldType: 'multi',
    isActive: true,
    placeholder: 'Select hair findings',
    options: [
      'Normal hair distribution',
      'Alopecia',
      'Hirsutism',
      'Brittle hair',
      'Oily hair',
      'Dry hair',
      'Thinning hair'
    ],
    default: ['Normal hair distribution'],
    ui: {
      span: 6,
      variant: 'checkbox',
      display: 'chip'
    },
    code: '386045008', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'capillary_refill',
    label: 'Capillary Refill',
    category: 'Skin',
    subcategory: 'Palpation',
    fieldType: 'single',
    isActive: true,
    placeholder: 'Select capillary refill time',
    options: [
      '< 2 seconds (Normal)',
      '2-3 seconds (Delayed)',
      '> 3 seconds (Significantly delayed)',
      'Unable to assess'
    ],
    default: '< 2 seconds (Normal)',
    ui: {
      span: 4,
      variant: 'select',
      display: 'dropdown'
    },
    code: '44966007', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'pressure_points',
    label: 'Pressure Points',
    category: 'Skin',
    subcategory: 'Inspection',
    fieldType: 'multi',
    isActive: true,
    placeholder: 'Select pressure point findings',
    options: [
      'No pressure areas',
      'Sacrum redness',
      'Heel pressure areas',
      'Elbow pressure areas',
      'Hip pressure areas',
      'Stage 1 pressure ulcer',
      'Stage 2 pressure ulcer',
      'Stage 3 pressure ulcer',
      'Stage 4 pressure ulcer'
    ],
    default: ['No pressure areas'],
    ui: {
      span: 8,
      variant: 'checkbox',
      display: 'chip'
    },
    code: '421076008', // SNOMED CT
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default skinDataPoints
